import { CommonModule } from '@angular/common';
import { Component, Input, input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from '../../theme.service';
import { NotificationCenterComponent } from "../notification-center/notification-center.component";

@Component({
    selector: 'app-topbar',
    imports: [CommonModule, NotificationCenterComponent],
    templateUrl: './topbar.component.html',
    styleUrl: './topbar.component.scss'
})
export class TopbarComponent implements OnInit {
  @Input() title: string = "";
  hiddenNotifications = true;
  notifications: any[] = [];
   headerTxt=''
   _subscription: any;
   _subscriptionNotifcations:any;
     darkModeEnabled!: boolean;
   constructor(private router:Router,private themeService:ThemeService){
    this.darkModeEnabled = localStorage.getItem('theme') == "dark" ? true : false;
 
  
    this._subscriptionNotifcations= themeService.showNotification.subscribe((value)=>{
      this.hiddenNotifications=value;
    })
 

    this._subscription = this.themeService.changeTheme.subscribe((value) => {
      this.darkModeEnabled = value;

    });
   }
  
  showNotifications() {
    this.hiddenNotifications = !this.hiddenNotifications;
  }
  ngOnInit(): void {
    this.notifications.push({
      idNotification: 1,
      shortMessage: "!Ya puedes usar tu tarjeta maestra!",
      fullMessage: "!Ya puedes usar tu tarjeta maestra!",

    },
      {
        idNotification: 1,
        shortMessage: "Tu usuario Jorge Arenas fue dado de alta éxitosamente",
        fullMessage: "!Ya puedes usar tu tarjeta maestra!",

      }
    )
  }
}
